import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { SupportFooterComponent } from "../support-footer/support-footer.component";

@Component({
  selector: "app-unauthorized",
  standalone: true,
  imports: [CommonModule, ButtonModule, SupportFooterComponent],
  templateUrl: "./unauthorized.component.html",
  styleUrls: ["./unauthorized.component.scss"]
})
export class UnauthorizedComponent {
  constructor(private router: Router) { }

  goToLogin(): void {
    // Redirect to login page
    this.router.navigate(["/"]);
  }
}
